import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "scenario-field-header with-elements bg-secondary text-white" }
const _hoisted_2 = { class: "float-end" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "mx-auto" }
const _hoisted_5 = ["disabled", "value"]
const _hoisted_6 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_7 = { class: "row partner-modal" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "row partner-modal" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = {
  key: 0,
  class: "col-12"
}
const _hoisted_12 = { class: "alert alert-danger mt-3" }
const _hoisted_13 = { class: "d-flex justify-content-end" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "card-body pt-4" }
const _hoisted_16 = {
  key: 0,
  class: "scenario-field-title text-center"
}
const _hoisted_17 = {
  key: 1,
  class: "row mb-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_modal = _resolveComponent("modal")!
  const _component_scenario_partner_distribution_field = _resolveComponent("scenario-partner-distribution-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[11] || (_cache[11] = _createTextVNode(" Partner Distribution ")),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_modal, {
          modelValue: _ctx.modal,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modal) = $event))
        }, _createSlots({
          header: _withCtx(() => [
            _cache[7] || (_cache[7] = _createTextVNode("Select a Partner to Add"))
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Loading, {
              active: _ctx.loading,
              "is-full-page": false
            }, null, 8, ["active"]),
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePartners, (item, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    disabled: _ctx.partners.find((i)=>i.id === item.id),
                    key: index,
                    value: item.id
                  }, _toDisplayString(item.long_name), 9, _hoisted_5))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selected]
              ]),
              (_ctx.partner_error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.partner_error), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-6 mt-2" }, "Make Scenario Featured?", -1)),
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.featured) = $event))
                  }, _cache[8] || (_cache[8] = [
                    _createElementVNode("option", { value: "0" }, "No", -1),
                    _createElementVNode("option", { value: "1" }, "Yes", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.featured]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-6 mt-2" }, "Job Number", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.job_number) = $event)),
                    maxlength: "255",
                    class: "job_number_edit"
                  }, null, 512), [
                    [_vModelText, _ctx.job_number]
                  ])
                ]),
                (_ctx.job_number_error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.job_number_error), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                class: "btn btn-default mx-2",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modal = !_ctx.modal))
              }, _toDisplayString(_ctx.partners.length === _ctx.availablePartners.length ? 'Done' : 'Cancel'), 1),
              (_ctx.partners.length !== _ctx.availablePartners.length)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    disabled: _ctx.loading,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args))),
                    class: "btn btn-primary"
                  }, "Add", 8, _hoisted_14))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, [
          (_ctx.canEdit)
            ? {
                name: "trigger",
                fn: _withCtx((triggerProps) => [
                  _createElementVNode("button", {
                    onClick: triggerProps.click,
                    type: "button",
                    class: "btn slim-button btn-primary"
                  }, _cache[6] || (_cache[6] = [
                    _createElementVNode("span", { class: "fa fa-plus" }, null, -1),
                    _createTextVNode(" Add ")
                  ]), 8, _hoisted_3)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      (_ctx.partners.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, " No Partners Selected "))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[12] || (_cache[12] = [
            _createElementVNode("div", { class: "col-5" }, [
              _createElementVNode("strong", { class: "fw-bold" }, "Partner")
            ], -1),
            _createElementVNode("div", { class: "col-7" }, [
              _createElementVNode("strong", { class: "fw-bold" }, "Featured")
            ], -1)
          ]))),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarioPartners, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "scenario-field-title",
          key: item.partner_id
        }, [
          _createVNode(_component_scenario_partner_distribution_field, {
            "can-edit": _ctx.canEdit,
            item: item,
            scenario: _ctx.scenario,
            onUpdateFeatured: _ctx.scenarioPartnerUpdate,
            onDeletePartner: ($event: any) => (_ctx.scenarioDeletePartner(index))
          }, null, 8, ["can-edit", "item", "scenario", "onUpdateFeatured", "onDeletePartner"])
        ]))
      }), 128))
    ])
  ], 64))
}